import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Card,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  Nav,
  NavItem,
  Row,
  Spinner,
  NavLink,
} from "reactstrap";
import TableComponent from "./TableComponent"; // Assuming TableComponent is in the same directory
import { addSportBadgeReward } from "store/actions/contestAction";
import { getParticipantList } from "store/actions/contestAction";
import { getContests } from "store/actions/contestAction";
import cross from "../assets/img/cross.svg";
import { getSuggestAthlete } from "store/actions/contestAction";
import moment from "moment";
import { fetchContests } from "store/actions/sportContestAction";
import { approveContest } from "store/actions/sportContestAction";
import { rejectContest } from "store/actions/sportContestAction";
import ConfirmationModal from "./Modal/ConfirmationModal";
import ContestDetails from "./ContestDetails";

const tabs = [
  { id: "contestRequests", name: "Contest Requests", status: "pending" },
  { id: "activeContests", name: "Active Contests", status: "accepted" },
  {
    id: "completedContests",
    name: "Completed Contests",
    status: ["admin action pending", "completed", "rewarded"],
  },
];

const SportContest = ({
  contestId,
  athleteList,
  setAddAthleteModal,
  setAthleteList,
  setAthleteListLoader,
  setContestId,
}) => {
  const dispatch = useDispatch();
  const {
    contestData,
    lastDocument,
    hasMoreDocument,
    suggestedAthlete,
    lastDocumentSuggestedAthlete,
    hasMoreSuggestedAthlete,
  } = useSelector((state) => state.contest);

  const [dataLoader, setDataLoader] = useState(false);
  const [loadMoreLoader, setLoadMoreLoader] = useState(false);
  const [leaderBoardModal, setLeaderBoardModal] = useState(false);
  const [round1Details, setRound1Details] = useState([]);
  const [athletePoints, setAthletePoints] = useState(0);
  const [round2Details, setRound2Details] = useState([]);
  const [round1Modal, setRound1Modal] = useState(false);
  const [round2Modal, setRound2Modal] = useState(false);
  const [leaderBoardData, setLeaderBoardData] = useState({});
  const [sportBadgeReward, setSportBadgeReward] = useState("");
  const [qrCode, setqrCode] = useState("");

  const [suggestedCollectionId, setSuggestedCollectionId] = useState("");
  const [suggestionModal, setsSuggestionModal] = useState(false);
  const [modalLoader, setModalLoader] = useState(false);
  const [rewardLoader, setRewardLoader] = useState(false);

  const [activeTab, setActiveTab] = useState(tabs[0]?.id);
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [actionType, setActionType] = useState("");
  const [activeId, setActiveId] = useState(null);
  const [confirmationModal, setConfirmationModal] = useState(false);

  const [activeContestId, setActiveContestId] = useState(null);
  const [detailsModal, setDetailsModal] = useState(false);

  const detailsModalToggler = () => {
    if (detailsModal) {
      setActiveContestId(null);
    }
    setDetailsModal(!detailsModal);
  };

  const toggleTab = (tab) => {
    setActiveTab(tab);
  };

  const confirmationModalToggler = () => {
    if (confirmationModal) {
      setActionType("");
      setActiveId(null);
    }
    setConfirmationModal(!confirmationModal);
  };

  const toggleRound1 = () => {
    if (round1Modal) {
      setAthletePoints(0);
    }
    setRound1Modal(!round1Modal);
  };
  const toggleRound2 = () => {
    setRound2Modal(!round2Modal);
  };
  const toggleLeaderBoardModal = () => {
    setLeaderBoardModal(!leaderBoardModal);
  };

  const formateDate = (firestoreTimestamp) => {
    if (!firestoreTimestamp || !firestoreTimestamp.seconds) return "N/A";

    const jsDate = new Date(
      firestoreTimestamp.seconds * 1000 +
        (firestoreTimestamp.nanoseconds || 0) / 1000000
    );
    const formattedDate = jsDate.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    return formattedDate.split("/").join("-");
  };

  const checkLastDate = (dateString) => {
    if (dateString === "N/A") return { bool: false, text: "Add Athlete" };

    const dateParts = dateString.split("-");
    const day = parseInt(dateParts[0], 10);
    const month = parseInt(dateParts[1], 10) - 1;
    const year = parseInt(dateParts[2], 10);

    const formattedDate = new Date(year, month, day);
    const currentDate = new Date();

    formattedDate.setHours(0, 0, 0, 0);
    currentDate.setHours(0, 0, 0, 0);

    if (formattedDate.getTime() === currentDate.getTime()) {
      return { bool: true, text: "Add Athlete" };
    } else if (formattedDate.getTime() < currentDate.getTime()) {
      return { bool: true, text: "LeaderBoard" };
    } else {
      return { bool: false, text: "Add Athlete" };
    }
  };

  const handleSubmit = () => {
    setRewardLoader(true);
    let reward = {
      sportBadgeReward: sportBadgeReward / leaderBoardData.leaderBoard?.length,
      leaderData: leaderBoardData.leaderBoard,
      qrCode: qrCode,
      contestId: leaderBoardData.id,
    };
    dispatch(
      addSportBadgeReward(reward, (res) => {
        setRewardLoader(false);
        if (res !== "error") {
          setLeaderBoardData((prev) => ({
            ...prev,
            status: "rewarded",
            rewardedAmount: reward.sportBadgeReward,
          }));
          setSportBadgeReward("");
        }
      })
    );
  };

  const toggleModal = () => {
    setsSuggestionModal(!suggestionModal);
  };

  const handleGetSuggestion = (id) => {
    setSuggestedCollectionId(id);
    setModalLoader(true);
    toggleModal();
    dispatch(
      getSuggestAthlete(id, "", () => {
        setModalLoader(false);
      })
    );
  };

  const loadMoreGetSuggestion = () => {
    setLoadMoreLoader(true);
    dispatch(
      getSuggestAthlete(
        suggestedCollectionId,
        lastDocumentSuggestedAthlete,
        () => {
          setLoadMoreLoader(false);
        }
      )
    );
  };

  const intiateAction = (type, id) => {
    setActionType(type);
    setActiveId(id);
    confirmationModalToggler();
  };

  const handleUpdateStatus = () => {
    if (actionType === "approve") {
      setIsUpdating(true);
      dispatch(
        approveContest({
          id: activeId,
          status: "accepted",
        })
      )
        .then(() => confirmationModalToggler())
        .finally(() => setIsUpdating(false));
    } else if (actionType === "reject") {
      setIsUpdating(true);
      dispatch(rejectContest({ id: activeId }))
        .then(() => confirmationModalToggler())
        .finally(() => setIsUpdating(false));
    }
  };

  const handleLoadMore = () => {
    setIsLoading(true);
    dispatch(
      fetchContests({
        status: tabs.find((tab) => tab.id === activeTab)?.status,
        lastVisible: lastDocument,
      })
    ).finally(() => setIsLoading(false));
  };

  useEffect(() => {
    setDataLoader(true);
    dispatch(
      fetchContests({
        status: tabs.find((tab) => tab.id === activeTab)?.status,
      })
    ).finally(() => setDataLoader(false));
  }, [activeTab]);

  // Prepare data for the table component
  const getTableData = () => {
    if (!contestData) return [];

    return contestData.map((contest) => {
      const formattedStartDate = formateDate(contest?.startDate);
      const formattedEndDate = formateDate(contest?.endDate);
      const formattedCreatedAt = formateDate(contest?.createdAt);
      const lastDateCheck = checkLastDate(formattedEndDate);

      return {
        contestID: contest?.contestID || "N/A",
        sportName: contest?.sportName || "N/A",
        total_buy_amount: contest?.total_buy_amount || 0,
        ffSeason: contest?.ffSeason || "N/A",
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        createdAt: formattedCreatedAt,
        status: contest?.status,
        id: contest?.id,
        lastDateCheck: lastDateCheck,
        participantList: contest?.participantList,
      };
    });
  };

  // Define columns based on active tab
  const getColumns = () => {
    const baseColumns = [
      "Sport",
      "TOTAL SPENT BY ALL FANS",
      "FF Season",
      "Start Date",
      "Buying End Date",
      "Created At",
    ];

    if (activeTab !== tabs[0]?.id) {
      return ["Contest Id", ...baseColumns];
    }

    return baseColumns;
  };

  // Define key map for the table component
  const getKeyMap = () => {
    const baseKeyMap = {
      Sport: "sportName",
      "TOTAL SPENT BY ALL FANS": "total_buy_amount",
      "FF Season": "ffSeason",
      "Start Date": "startDate",
      "Buying End Date": "endDate",
      "Created At": "createdAt",
    };

    if (activeTab !== tabs[0]?.id) {
      return {
        "Contest Id": "contestID",
        ...baseKeyMap,
      };
    }

    return baseKeyMap;
  };

  // Render action buttons for each row
  const renderActions = (row) => {
    if (row.status === "pending") {
      return (
        <>
          <Button
            color="primary"
            size="sm"
            onClick={() => intiateAction("approve", row.id)}
          >
            Approve
          </Button>
          <Button
            color="danger"
            size="sm"
            onClick={() => intiateAction("reject", row.id)}
          >
            Reject
          </Button>
        </>
      );
    } else {
      return (
        <>
          <Button
            size="sm"
            color="primary"
            onClick={() => {
              setActiveContestId(row.id);
              detailsModalToggler();
            }}
          >
            View Details
          </Button>
          <Button
            id="block"
            size="sm"
            color="primary"
            value={row.lastDateCheck.text}
            disabled={
              !row.lastDateCheck.bool && row.status !== "admin action pending"
            }
            onClick={(e) => {
              if (e.target.value === "Add Athlete") {
                setContestId(row.id);
                setAthleteListLoader(true);
                const isSameContest = contestId === row.id;
                if (!isSameContest) {
                  setAthleteList([]);
                }
                row.participantList
                  ? dispatch(
                      getParticipantList(row.participantList, (data) => {
                        setAthleteListLoader(false);
                        if (!isSameContest) {
                          setAthleteList(data);
                        } else {
                          // If same contest, append any new participants not already in the list
                          setAthleteList((prevList) => {
                            const existingIds = new Set(prevList.map(a => a.athleteId));
                            const newParticipants = data.filter(p => !existingIds.has(p.athleteId));
                            return [...prevList, ...newParticipants];
                          });
                        }
                      })
                    )
                  : setAthleteListLoader(false);
                setAddAthleteModal(true);
              } else if (e.target.value === "LeaderBoard") {
                // Find the original contest data to set in leaderboard modal
                const originalContest = contestData.find(
                  (contest) => contest.id === row.id
                );
                setLeaderBoardData(originalContest);
                setLeaderBoardModal(true);
              }
            }}
          >
            {row.lastDateCheck.text === "Add Athlete" ? (
              <>
                <i className="fa fa-plus mr-1"></i> Add Athlete
              </>
            ) : (
              "LeaderBoard"
            )}
          </Button>
          {(row.status === "accepted" ||
            row.status === "admin action pending") && (
            <Button
              size="sm"
              color="primary"
              onClick={() => handleGetSuggestion(row.id)}
            >
              See Suggestions
            </Button>
          )}
        </>
      );
    }
  };

  return (
    <>
      <Nav
        tabs
        className="d-flex justify-content-start text-dark athlete_earning-nav"
      >
        {tabs.map((tab) => (
          <NavItem key={tab?.id}>
            <NavLink
              className={
                activeTab === tab?.id
                  ? "active active-tab py-2 bg-primary"
                  : "text-dark cursor-pointer py-2"
              }
              onClick={() => toggleTab(tab?.id)}
            >
              <h2 className={activeTab === tab?.id ? "text-white" : ""}>
                {tab?.name}
              </h2>
            </NavLink>
          </NavItem>
        ))}
      </Nav>

      {dataLoader ? (
        <div className="p-3 d-flex justify-content-center">
          <Spinner size="md" />
        </div>
      ) : (
        <>
          <TableComponent
            columns={getColumns()}
            data={getTableData()}
            keyMap={getKeyMap()}
            renderActions={renderActions}
          />

          {!dataLoader && contestData?.length > 4 && (
            <div className="w-100 py-4 d-flex justify-content-center">
              <Button
                color="primary"
                onClick={handleLoadMore}
                disabled={!hasMoreDocument || isLoading}
              >
                {isLoading ? <Spinner size="sm" /> : "Load More"}
              </Button>
            </div>
          )}
        </>
      )}

      <Modal
        isOpen={leaderBoardModal}
        toggle={toggleLeaderBoardModal}
        size="xl"
        fullscreen
      >
        <ModalBody className="overflow-auto">
          {leaderBoardData.status === "completed" && (
            <>
              <p className="custom-table-heading custom-heading text-center">
                Winners Reward
              </p>
              <div className="">
                <Row>
                  <Col lg="6">
                    <Label className="mt-2">Sport Badge Reward</Label>
                    <Input
                      placeholder="Enter amount"
                      value={sportBadgeReward}
                      onChange={(e) =>
                        setSportBadgeReward(Number(e.target.value))
                      }
                    />
                  </Col>
                  <Col lg="6">
                    <FormGroup className="d-flex flex-column">
                      <Label for="exampleSelect">QR Code</Label>
                      {qrCode && (
                        <div className="position-relative">
                          <img
                            src={URL.createObjectURL(qrCode)}
                            alt=""
                            className="mb-3"
                            width={80}
                            height={80}
                          />
                          <img
                            src={cross}
                            width={20}
                            alt=""
                            className="position-absolute"
                            style={{
                              top: "-11%",
                              left: "39%",
                              cursor: "pointer",
                            }}
                            onClick={() => setqrCode("")}
                          />
                        </div>
                      )}
                      {!qrCode && (
                        <Input
                          id="exampleSelect"
                          name="select"
                          type="file"
                          accept="image/*"
                          onChange={(e) => {
                            const file = e.target.files[0];
                            if (file) {
                              setqrCode(file);
                            }
                          }}
                        ></Input>
                      )}
                    </FormGroup>{" "}
                  </Col>
                </Row>
                <div className="text-right">
                  <Button
                    color="primary"
                    className="sportRewardbtn"
                    onClick={handleSubmit}
                  >
                    {rewardLoader ? <Spinner size="sm" /> : " Submit"}
                  </Button>
                </div>
              </div>

              <hr />
            </>
          )}
          {leaderBoardData.status !== "pending" && (
            <>
              <p className="custom-table-heading custom-heading text-center">
                LeaderBoard
              </p>
              <TableComponent
                columns={[
                  "Fan Name",
                  "Fan Email",
                  "Reward Amount",
                  "Total Points",
                ]}
                data={
                  leaderBoardData?.leaderBoard?.map((item) => ({
                    fanName: item.fanName || "N/A",
                    email: item.email || "N/A",
                    rewardAmount: leaderBoardData.rewardedAmount || "pending",
                    totalPoints: item.totalPoints || 0,
                  })) || []
                }
                keyMap={{
                  "Fan Name": "fanName",
                  "Fan Email": "email",
                  "Reward Amount": "rewardAmount",
                  "Total Points": "totalPoints",
                }}
              />
              <hr />
            </>
          )}
          <p className="custom-table-heading custom-heading text-center mt-4">
            Round One
          </p>
          <TableComponent
            columns={["Fan Name", "Fan Email", "Total points"]}
            data={
              leaderBoardData?.round1?.map((item) => ({
                fanName: item.fanName || "N/A",
                email: item.email || "N/A",
                totalPoints: item.totalPoints || 0,
                pointDetails: item.pointDetails,
                rowData: item,
              })) || []
            }
            keyMap={{
              "Fan Name": "fanName",
              "Fan Email": "email",
              "Total points": "totalPoints",
            }}
            renderActions={(row) => (
              <Button
                color="primary"
                size="sm"
                onClick={() => {
                  setRound1Details(row.pointDetails);
                  setAthletePoints(row.totalPoints);
                  toggleRound1();
                }}
              >
                View Details
              </Button>
            )}
          />
          {leaderBoardData?.round2 ? (
            <>
              <hr />
              <p className="custom-table-heading custom-heading text-center mt-4">
                Round Two
              </p>
              <TableComponent
                columns={["Fan Name", "Fan Email", "Total points"]}
                data={
                  leaderBoardData?.round2?.map((item) => ({
                    fanName: item.fanName || "N/A",
                    email: item.email || "N/A",
                    totalPoints: item.totalPoints || 0,
                    pointDetails: item.pointDetails,
                  })) || []
                }
                keyMap={{
                  "Fan Name": "fanName",
                  "Fan Email": "email",
                  "Total points": "totalPoints",
                }}
                renderActions={(row) => (
                  <Button
                    color="primary"
                    size="sm"
                    onClick={() => {
                      setRound2Details(row.pointDetails);
                      toggleRound2();
                    }}
                  >
                    View Details
                  </Button>
                )}
              />
            </>
          ) : (
            <p className="custom-table-heading custom-heading text-center mt-4">
              {leaderBoardData.status === "pending"
                ? "Waiting For Run Round Two"
                : "No Need Run Round Two"}
            </p>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={toggleLeaderBoardModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={round1Modal} toggle={toggleRound1} size="xl" fullscreen>
        <ModalBody className="overflow-auto">
          <TableComponent
            columns={[
              "Athlete Name",
              "Athlete Email",
              "Athlete Id",
              "Total Points",
            ]}
            data={
              round1Details?.map((item) => ({
                athleteName: item.first_name + " " + item.last_name || "N/A",
                email: item.email || "N/A",
                athleteID: item.athleteID || "N/A",
                totalPoints: athletePoints || 1,
              })) || []
            }
            keyMap={{
              "Athlete Name": "athleteName",
              "Athlete Email": "email",
              "Athlete Id": "athleteID",
              "Total Points": "totalPoints",
            }}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={toggleRound1}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={round2Modal} toggle={toggleRound2} size="xl" fullscreen>
        <ModalBody className="overflow-auto">
          <TableComponent
            columns={[
              "Athlete Name",
              "Athlete Email",
              "Buy Seasonal",
              "Buy Momento",
              "Buy Talking",
              "Buy Sport",
              "Buy Endorsement",
              "Buy Chat",
            ]}
            data={
              round2Details?.map((item) => ({
                athleteName:
                  item?.athleteData?.first_name +
                    " " +
                    item?.athleteData?.last_name || "N/A",
                email: item?.athleteData?.email || "N/A",
                seasonalBadges: item?.seasonal_badges || 0,
                momentos: item?.momentos || 0,
                talkingBadges: item?.talking_badges || 0,
                sportBadges: item?.sport_badges || 0,
                endorsementBadges: item?.endorsement_badges || 0,
                chats: item?.chats || 0,
              })) || []
            }
            keyMap={{
              "Athlete Name": "athleteName",
              "Athlete Email": "email",
              "Buy Seasonal": "seasonalBadges",
              "Buy Momento": "momentos",
              "Buy Talking": "talkingBadges",
              "Buy Sport": "sportBadges",
              "Buy Endorsement": "endorsementBadges",
              "Buy Chat": "chats",
            }}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={toggleRound2}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={suggestionModal} centered toggle={toggleModal} size="xl">
        {modalLoader ? (
          <div className="text-center my-4">
            <Spinner color="primary" />
          </div>
        ) : (
          <ModalBody>
            <h2 className="text-center">Suggested Athlete</h2>
            <TableComponent
              columns={[
                "First Name",
                "Last Name",
                "FHP ID",
                "School",
                "Created At",
              ]}
              data={
                suggestedAthlete?.map((item) => ({
                  firstName: item?.athlete?.first_name || "N/A",
                  lastName: item?.athlete?.last_name || "N/A",
                  fhpID: item?.athlete_id || "N/A",
                  schoolName: item?.school?.instituteName || "N/A",
                  createdAt: item?.created_at?.seconds
                    ? moment.unix(item.created_at.seconds).format("DD-MM-YYYY")
                    : "N/A",
                })) || []
              }
              keyMap={{
                "First Name": "firstName",
                "Last Name": "lastName",
                "FHP ID": "fhpID",
                School: "schoolName",
                "Created At": "createdAt",
              }}
            />
            {suggestedAthlete?.length > 4 && (
              <div className="text-center py-4">
                <Button
                  color="primary"
                  onClick={loadMoreGetSuggestion}
                  disabled={
                    loadMoreLoader ||
                    !hasMoreSuggestedAthlete ||
                    suggestedAthlete.length === 0
                  }
                >
                  {loadMoreLoader ? <Spinner size="sm" /> : "Load More"}
                </Button>
              </div>
            )}
            <div className="text-right mt-4">
              <Button
                size="sm"
                className="ml-2"
                color="danger"
                onClick={() => {
                  toggleModal();
                }}
              >
                Close
              </Button>
            </div>
          </ModalBody>
        )}
      </Modal>

      <ContestDetails
        showModal={detailsModal}
        handleModalToggle={detailsModalToggler}
        contestId={activeContestId}
      />
      <ConfirmationModal
        isOpen={confirmationModal}
        toggle={confirmationModalToggler}
        onConfirm={handleUpdateStatus}
        isLoading={isUpdating}
        title={`${actionType} Contest`}
        message={`Are you sure you want to ${actionType} this contest?`}
      />
    </>
  );
};

export default SportContest;
